import Relay from 'react-relay';
import PropTypes from 'prop-types';
import LastOrganisationId from '../app/LastOrganisationId';

interface CheckLinkInvitationMutationProps {
 invitationId: string;
}

export default class CheckLinkInvitationMutation extends Relay.Mutation<CheckLinkInvitationMutationProps> {
    static propTypes = {
        invitationId: PropTypes.string.isRequired,
    };

    getMutation() {
        return Relay.QL`mutation {checkLinkInvitation}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on CheckLinkInvitationPayload {
                success,
                error,
                extraArgs
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ]
        }];
    }

    getVariables() {
        return {
            invitation_id: this.props.invitationId,
            organisation_id: LastOrganisationId.get()
        };
    }
}
